import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Footer from '../components/footer';
import '../css/pages_styles.css';

const Mc_submission = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [sidebarExpanded, setSidebarExpanded] = useState(true);

    // 偵測螢幕大小
    useEffect(() => {
        const checkScreenSize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 768);
        };

        // 初始檢查
        checkScreenSize();

        // 監聽視窗大小變化
        window.addEventListener('resize', checkScreenSize);
        
        // 清理事件監聽器
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // 監聽 sidebar 狀態變化的函數
    const handleSidebarToggle = (isExpanded) => {
        setSidebarExpanded(isExpanded);
    };

    return (
        <div style={{ display: 'flex', position: 'relative' }}>
            <Sidebar onToggle={handleSidebarToggle} />
            <div 
                className="main-content"
                style={{
                    marginLeft: isMobile ? '0' : (sidebarExpanded ? '250px' : '0')
                }}
            >
                <div className="container">
                    <header 
                        className="header"
                    >
                        <h1 className="title">MC 投稿</h1>
                    </header>
                    <section className={`section ${isMobile ? 'section-mobile' : ''}`}>
                        <h2 className="subtitle">論文投稿說明</h2>
                        <ul>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                論文投稿網址：
                                <a 
                                    href="https://cmt3.research.microsoft.com/MCWASN2025" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="link">
                                    請點我
                                </a>
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                Call For Papers：
                                <a 
                                    href="https://drive.google.com/file/d/1ZsKR6yNjg3U0nO-WKzjj5eYrGW6iJ7wK/view?usp=sharing" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="link">
                                    請點我
                                </a>
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                投稿論文可為2頁之<span className="red-text">摘要論文</span>或至多8頁之<span className="red-text">完整論文</span>。
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                論文請以A4格式書寫，並為Two Column, Single Spacing之格式設定。
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                投稿論文請以 Word 檔 (doc 或 docx) 及 PDF 檔上傳。
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                若為國科會計畫相關成果，請在論文之致謝中註明國科會計畫編號。
                            </li>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                大會將從<span className="red-text">完整論文</span>中挑選出數篇優質論文，須於會議現場口頭發表。
                            </li>
                        </ul>

                        <h2 className="subtitle">論文格式範例</h2>
                        <ul>
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                論文範例網址：
                                <a 
                                    href="https://docs.google.com/document/d/1PZljMeg0KHGGlvhgqzasA8rdtbElm5hq/edit?usp=sharing&ouid=115724323665868431051&rtpof=true&sd=true" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="link">
                                    請點我
                                </a>
                            </li>
                        </ul>

                        <h2 className="subtitle">致謝</h2>
                        <div className="acknowledgment-text">
                            <li className={`list-item ${isMobile ? 'list-item-mobile' : ''}`}>
                                <a href="https://cmt3.research.microsoft.com" className="link">Microsoft CMT service</a> was used for managing the peer-reviewing process for this conference. 
                            </li>
                            This service was provided for free by Microsoft and they bore all expenses, including costs for Azure cloud services as well as for software development and support.
                        </div>
                    </section>
                    <Footer/>
                </div>
            </div>
        </div>
    );
};

export default Mc_submission;